"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Track = function TrackForRangeInput(_ref) {
  var handleMouseDown = _ref.handleMouseDown,
      classPrefix = _ref.classPrefix,
      trackId = _ref.trackId,
      children = _ref.children,
      currentHandlePosition = _ref.currentHandlePosition;
  var handleAdjustment = 20;
  var barWidth = currentHandlePosition + handleAdjustment;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classPrefix, "__bar-wrapper")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    role: "button",
    tabIndex: 0,
    ref: trackId,
    className: "".concat(classPrefix, "__bar"),
    onMouseDown: function onMouseDown(event) {
      return handleMouseDown(event);
    },
    onTouchStart: function onTouchStart(event) {
      return handleMouseDown(event);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classPrefix, "__bar-complete"),
    style: {
      width: "".concat(barWidth, "px")
    }
  }), children));
};

Track.propTypes = {
  currentHandlePosition: _propTypes["default"].number.isRequired,
  handleMouseDown: _propTypes["default"].func.isRequired,
  classPrefix: _propTypes["default"].string.isRequired,
  trackId: _propTypes["default"].shape({}).isRequired,
  children: _propTypes["default"].arrayOf(_propTypes["default"].element).isRequired
};
var _default = Track;
exports["default"] = _default;